import { FC } from "react";
import CustomSelect from "../../../components/forms/CustomSelect";
import DateField from "../../../components/forms/DateField";
import RequiredInput from "../../../components/forms/InputHOC";
import useUsers from "../../../hooks/api-calls/useUsers";
import useVehicles from "../../../hooks/api-calls/useVehicles";
import CustomTextDelayInput from "../../../components/forms/CustomTextDelayInput";
import useCompanies from "../../../hooks/api-calls/useCompanies";
import { usePrivilege } from "../../../components/priviledge/PriviledgeProvider";

interface RefuelsFiltersProps {
    updateFilters: (filters: any) => void;
    filters: any;
}

const RefuelsFilters: FC<RefuelsFiltersProps> = ({ filters, updateFilters }) => {

    // HOOKS
    const { getVehiclesList, vehiclesLoading } = useVehicles();
    const { getUsersList } = useUsers();
    const { getCompaniesList } = useCompanies();

    const {userCan} = usePrivilege();
    // RENDER

    return (
        <>
            <CustomSelect
                isSearchable
                isClearable
                isLoading={vehiclesLoading}
                id={'vehicle_id'}
                label="Vehículo"
                placeholder="Seleccionar vehículo"
                value={filters.filter_filters?.vehicle_id ? { value: filters.filter_filters?.vehicle_id, label: getVehiclesList()?.find((g: any) => g.value === filters.filter_filters?.vehicle_id)?.label } : null}
                options={getVehiclesList()}
                onChange={(value: any) => updateFilters({ vehicle_id: value?.value })}
            />

            <CustomSelect
                isSearchable
                isClearable
                id={'user_id'}
                label="Usuario"
                placeholder="Seleccionar usuario"
                value={filters.filter_filters?.user_id ? { value: filters.filter_filters?.user_id, label: getUsersList()?.find((u: any) => u.value === filters.filter_filters?.user_id)?.label } : null}
                options={getUsersList()}
                onChange={(value: any) => updateFilters({ user_id: value?.value })}
            />

            <DateField
                isClearable
                className="w-full"
                label="Rango de fechas"
                placeholderText="Selecciona las fechas"
                selectedDateField={filters.filter_filters?.between_dates?.type || "refuelDate"}
                dateTypesOptions={[
                    { label: "Fecha de repostaje", value: "refuelDate" },
                    { label: "Fecha de creación", value: "createdAt" },
                ]}
                startDate={filters.filter_filters?.between_dates?.startDate ? new Date(filters.filter_filters.between_dates.startDate) : null}
                endDate={filters.filter_filters?.between_dates?.endDate ? new Date(filters.filter_filters.between_dates.endDate) : null}
                onChange={(date: any) => {
                    const filters_between_dates = filters.filter_filters?.between_dates;
                    const between_dates = date ? { startDate: date[0], endDate: date[1] } : null;
                    if (between_dates && filters_between_dates !== between_dates) {
                        updateFilters({ between_dates: { startDate: date[0], endDate: date[1], type: date[2] } });
                    } else if (!between_dates && filters_between_dates) {
                        updateFilters({ between_dates: null });
                    }
                }}
            />

                        <div className="grid grid-cols-2 gap-3">
                <CustomTextDelayInput
                    id="min_liters"
                    label="Litros mínimos"
                    placeholder="Ingrese litros"
                    type="number"
                    step="0.01"
                    min="0"
                    filters={filters}
                    updateFilters={updateFilters}
                    isClearable={true}
                    onClear={() => updateFilters({ min_liters: null })}
                    suffix="L"
                />
                <CustomTextDelayInput
                    id="max_liters"
                    label="Litros máximos"
                    placeholder="Ingrese litros"
                    type="number"
                    step="0.01"
                    min="0"
                    filters={filters}
                    updateFilters={updateFilters}
                    isClearable={true}
                    onClear={() => updateFilters({ max_liters: null })}
                    suffix="L"
                />
            </div>

            <div className="grid grid-cols-2 gap-3">
                <CustomTextDelayInput
                    id="min_cost"
                    label="Costo mínimo"
                    placeholder="Ingrese costo"
                    type="number"
                    step="0.01"
                    min="0"
                    filters={filters}
                    updateFilters={updateFilters}
                    isClearable={true}
                    onClear={() => updateFilters({ min_cost: null })}
                    suffix="€"
                />
                <CustomTextDelayInput
                    id="max_cost"
                    label="Costo máximo"
                    placeholder="Ingrese costo"
                    type="number"
                    step="0.01"
                    min="0"
                    filters={filters}
                    updateFilters={updateFilters}
                    isClearable={true}
                    onClear={() => updateFilters({ max_cost: null })}
                    suffix="€"
                />
            </div>

            {userCan('list', 'company') && (
                <CustomSelect
                    id="company_id"
                    label="Compañía"
                    placeholder="Seleccionar compañía"
                    options={getCompaniesList()}
                    value={filters.filter_filters?.company_id ? { value: filters.filter_filters?.company_id, label: getCompaniesList()?.find((g: any) => g.value === filters.filter_filters?.company_id)?.label } : null}
                    onChange={(value: any) => updateFilters({ company_id: value?.value })}
                />
            )}
        </>
    );
};

export default RefuelsFilters;